import { userEndpoints } from "./user.api.ts"

export const {
  useAuthMutation,
  useGetUserDataQuery,
  useGetReferredUsersQuery,
  useCollectRewardsFromReferralsMutation,
  useSetDogNameMutation,
  useSetSoundMuteMutation,
  useBuyPackageMutation,
  useGetReferrerQuery,
  useHideUserNameMutation,
  useExchangeStarsToGoldMutation,
  useCheckDailyAndInvitesMutation,
  useGetReferralsCountQuery,
  useGetCurrentLeaderProgressQuery,
  useRefreshMyPositionInLeadersMutation,
  useCheckCurrentUserRoleMutation,
  useSentVerificationEmailCodeMutation,
  useSentDetachEmailCodeMutation,
  useVerifyDetachEmailCodeMutation,
  useVerifyEmailCodeMutation,
  useGetBalanceHistoryQuery,
  useGetTotalStarsEarnedQuery,
  useGetUserStatsQuery,
  useGetUserBoughtGoldQuery,
  useGetUserLeaderboardShortInfoQuery,
  useMarkUserGuiHasReadMutation,
  useGetUserGameStatisticsQuery,
  useGetUserSettingsQuery,
  useSetLangMutation,
  endpoints: {
    auth,
    getUserData,
    getReferredUsers,
    collectRewardsFromReferrals,
    setDogName,
    setSoundMute,
    buyPackage,
    getReferrer,
    hideUserName,
    exchangeStarsToGold,
    refreshMyPositionInLeaders,
    sentVerificationEmailCode,
    verifyEmailCode,
    getUserStats,
    getUserBoughtGold,
    getUserGameStatistics,
    getUserSettings,
    setLastOpenApp
  }
} = userEndpoints

export { default as userSelectors } from "./user.selectors"
